import {getInstance as checker} from './AccessRightsChecker'

export const hasManageUsersRight = (user) => checker().hasManageUsersRight(user)
export const hasSubmitOtherUsersTTRight = (user) => checker().hasSubmitOtherUsersTTRight(user)
export const hasEditHierarchyRight = (user) => checker().hasEditHierarchyRight(user)
export const hasGenerateMoneyReportsRight = (user) => checker().hasGenerateMoneyReportsRight(user)

export const hasSubmitTTRight = (user) => checker().hasSubmitTTRight(user)
export const hasLockTTRight = (user) => checker().hasLockTTRight(user)
export const hasManagePtoAndSickDays = (user) => checker().hasManagePtoAndSickDays(user)
export const hasManageSystemSettingsRight = (user) => checker().hasManageSystemSettingsRight(user)

export const canAccessManagersScope = (user) => checker().canAccessManagersScope(user)
export const canAccessAllManagementScope = (user) => checker().canAccessAllManagementScope(user)
export const canAccessAllTeamScope = (user) => checker().canAccessAllTeamScope(user)
export const hasSomeTeamAssignment = (user) => checker().hasSomeTeamAssignment(user)


// WEBPACK FOOTER //
// ./web/js/util/accessRightsUtils.js